export enum VehicleType {
  TWO_WHEELER = 'TWO_WHEELER',
  PRIVATE_CAR = 'PRIVATE_CAR',
}

export const isTwoWheeler = (vehicleType: string): boolean => vehicleType === VehicleType.TWO_WHEELER

export const isNotPrivateCar = (vehicleType: string): boolean => vehicleType !== VehicleType.PRIVATE_CAR
